import { render, staticRenderFns } from "./WMS.vue?vue&type=template&id=d8c8163e&scoped=true"
import script from "./WMS.vue?vue&type=script&lang=js"
export * from "./WMS.vue?vue&type=script&lang=js"
import style0 from "./WMS.vue?vue&type=style&index=0&id=d8c8163e&lang=scss&scoped=scoped"
import style1 from "./WMS.vue?vue&type=style&index=1&id=d8c8163e&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c8163e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c8163e')) {
      api.createRecord('d8c8163e', component.options)
    } else {
      api.reload('d8c8163e', component.options)
    }
    module.hot.accept("./WMS.vue?vue&type=template&id=d8c8163e&scoped=true", function () {
      api.rerender('d8c8163e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wms/WMS.vue"
export default component.exports